import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';
import styles from './FilterList.module.scss';
interface FilterListProps {
	filters: {
		name: string;
		count: number;
		selected?: boolean;
	}[];
	onClick: (filter: string) => void;
}

export const UI_FilterList = ({ filters, onClick }: FilterListProps) => {
	const handleFilterClick = (filter: string) => {
		onClick(filter);
	};
	return (
		<div className={styles.FilterList}>
			{filters?.map((filter, index) => {
				return (
					<UI_Button
						type="button"
						style={filter.selected ? 'theme' : 'theme-reverse'}
						size="small"
						key={index}
						onClick={() => handleFilterClick(filter.name)}
					>
						{`${filter.name} (${filter.count})`}
					</UI_Button>
				);
			})}
		</div>
	);
};
